import { render, staticRenderFns } from "./root.vue?vue&type=template&id=df3ad7a2&scoped=true&lang=pug&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"
import style0 from "./root.vue?vue&type=style&index=0&id=df3ad7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3ad7a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df3ad7a2')) {
      api.createRecord('df3ad7a2', component.options)
    } else {
      api.reload('df3ad7a2', component.options)
    }
    module.hot.accept("./root.vue?vue&type=template&id=df3ad7a2&scoped=true&lang=pug&", function () {
      api.rerender('df3ad7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/root.vue"
export default component.exports